import styled from "styled-components";
import FullWidthDiv from "@/react/features/styled/FullWidthDiv";

export const DetailsCardContainer = styled(FullWidthDiv)`
  overflow: auto;
  padding: 16px;
`;

export const ReplaceModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  padding: 8px 16px;
`;

export const CampaignInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));
  width: 100%;
`;

export const CampaignButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
`;
